const racesQuest = `

#### Unlocking Race Buffs
- This quest allows you to obtain the **Deva, Asura, and Gaia buffs** from Buff Daddy.
- **Requirements:** Reach level **100** and talk to **Buff Daddy** to start the quest.

#### Main Quest: The Power of the Race
- **Objective:** Kill **Frostjewels, Freesia, and Ice Maiden** in Marduka's Realm.
- ![Marduka's Realm](assets/guide/kainenus.png)

#### Follow-Up Quests

**For Deva Race**
- **Quest:** *Power of the Deva*
- **Objective:** Kill **2x Deva Guardian** in Laksy Ancient Remains.
- ![Deva Guardian](assets/guide/wachterdevaus.png)

**For Gaia Race**
- **Quest:** *Power of the Gaia*
- **Objective:** Kill **2x Gaia Guardian** in Horizon Second Valmore Mine.
- ![Gaia Guardian](assets/guide/wachtergaiaus.png)

**For Asura Race**
- **Quest:** *Power of the Asura*
- **Objective:** Kill **2x Asura Guardian** in Katan Lake Messi.
- ![Asura Guardian](http://fs1.directupload.net/images/180131/b2ocnv7f.jpg)

#### Rewards
- Completing each race quest grants **one emblem**:
  - 🏅 *Emblem of the Deva Race*
  - 🏅 *Emblem of the Gaia Race*
  - 🏅 *Emblem of the Asura Race*
- If you own all **three emblems**, you can **combine** them into:
  - 🏅 *Emblem of the Races* (No need to carry all three separately!)
- These **emblems are account-bound** and **not tradeable**.

#### Race Emblem Upgrade
- You can upgrade the **Race Emblem** at Buff Daddy up to **+10 Level 8**.
- The emblem **must be equipped** to upgrade.

#### Race Emblem Buff Increase
- To upgrade the **+ Buff**, trade **21 Buff Skill Cards +1** to Buff Daddy:
  - Each upgrade requires **two previous-level stones** (e.g., **2x +1 stones → +2 stone**).

#### Race Emblem Level Increase
- Increase emblem level by **mining resources** in the **Guild Zone/Mine**.
- Occasionally, a **Buff Level Upgrade Stone** will drop.

#### Race Emblem Buff Effects
- **+0 Level 1 Race Emblem** grants **base race buffs** (without skill cards/TR buffs).
- **+10 Level 1 Race Emblem** works like a **+10 skill card** for buffs.
- **Higher emblem levels** enhance buffs like **+24 Helmet, PW Equip, Belt, DT Buffs, etc.**

🎉 **Enjoy the game and power up your character with race buffs!** 🎉`;

export default racesQuest;
